<template>
  <div class="board" :class="boardClass">
    <header class="header">
      <AnimatedTitle></AnimatedTitle>
    </header>
    <div class="info">
      Find {{ numberOfCardTypes }} pairs!
      <strong>
        {{ moves }}
        <font-awesome-icon class="feet-icon" :icon="['fal', 'shoe-prints']"></font-awesome-icon>
      </strong>
      moves so far.
    </div>
    <div class="fields">
      <div class="field" v-for="card of board.cards" :key="'field-' + card.id">
        <Card
          :card="card"
          :selected="isSelected(card)"
          :found="isFound(card)"
          @select="selectCard"
        ></Card>
      </div>
    </div>
    <div class="controls">
      <button class="loser-button" @click="giveUp">
        This is too hard, I want to give up
        <font-awesome-icon :icon="['fal', 'frown']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/card/Card.vue';
  import { mapGetters, mapActions } from 'vuex';


  export default {
    name: 'Game',
    components: {
      Card,
    },
    props: {},
    computed: {
      ...mapGetters([
        'moves',
        'board',
        'boardSize',
        'numberOfCards',
        'numberOfCardTypes',
      ]),
      boardClass() {
        return `board--${this.boardSize}`;
      },
    },
    methods: {
      ...mapActions([
        'winGame',
        'loseGame',
        'incrementMoves',
      ]),
      selectCard(id) {
        this.board.selectCard(id, () => {
          this.incrementMoves();
        });

        if (this.board.foundAllPairs) {
          this.winGame();
        }
      },
      isSelected(card) {
        return this.board.isSelected(card.id);
      },
      isFound(card) {
        return this.board.isFound(card.id);
      },
      giveUp() {
        if (confirm('Are you sure?')) {
          this.loseGame();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../config/styles/settings";
  @import "../config/styles/util";

  $flex-gap: ($gutter * 0.25);

  .header {
    padding-top: $gutter;
    font-size: 3rem;
  }

  .fields {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: $gutter;
    margin: 0 auto;
    // 4 items per row default
    max-width: 660px;

    @include md-only {
      padding: ($gutter * 0.5);
    }

    @include sm-down {
      padding: ($gutter * 0.25);
    }
  }

  .board.board--2 .fields {
    // max. 2 items per row
    max-width: 360px;
  }

  .board.board--4 .fields {
    // max. 4 items per row
    max-width: 680px;

  }

  .board.board--6 .fields {
    // max. 6 items per row
    max-width: 1020px;
  }

  .board.board--8 .fields {
    // max. 8 items per row
    max-width: 1360px;
  }

  .field {
    margin: $flex-gap;
    width: 150px;
    flex-basis: 150px;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .info {
    padding: $gutter $gutter 0 $gutter;
    text-align: center;
  }

  .feet-icon {
    font-size: 0.9em;
  }

  .controls {
    padding: ($gutter * 2) $gutter $gutter $gutter;
    text-align: center;
  }

  .loser-button {
    @include reset-button;
    color: $blue-400;
  }
</style>
